var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NavHeader'),_c('NavHeaderMobile'),_c('div',{staticClass:"ApplyCardContainer"},[_c('div',{staticClass:"step4Container"},[_c('a-icon',{staticClass:"topImg",style:({ 'font-size': '100px' }),attrs:{"type":"check-circle","theme":"twoTone"}}),_c('div',{staticClass:"step4Tips"},[_vm._v("Reset Password Success")])],1)]),_c('NewFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }